
export type KidsChoiceVideoChoice = KidsChoiceHealthVideos | KidsChoiceSecondHandVideos

export enum KidsChoiceHealthVideos {
    JUSTIN = "JUSTIN",
    REENA = "REENA",
}

export enum KidsChoiceSecondHandVideos {
    NOWHERE = "NOWHERE",
    TRAPPED = "TRAPPED",
}

export enum KidsChoiceCategoryType {
    HEALTH_EFFECTS = "Health Effects of Smoking",
    SECONDHAND_SMOKE = "Dangers of Secondhand Smoke"
}

export enum KidsChoiceSpriteType {
    CATEGORY_SELECT,
    VIDEO_SELECT
}

export interface KidsChoiceSprite {
    destroy: () => void
}

export interface KidsChoiceSpriteConfig {
    group?: Phaser.Group
    type?: KidsChoiceCategoryType
    onEnd?: () => void
}

export interface KidsChoiceSelections {
    healthChoice: KidsChoiceHealthVideos
    secondHandChoice: KidsChoiceSecondHandVideos
}
